import { render, staticRenderFns } from "./FooterMiniV2.vue?vue&type=template&id=ffd83d3e&scoped=true&"
import script from "./FooterMiniV2.vue?vue&type=script&lang=ts&"
export * from "./FooterMiniV2.vue?vue&type=script&lang=ts&"
import style0 from "./FooterMiniV2.vue?vue&type=style&index=0&id=ffd83d3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd83d3e",
  null
  
)

export default component.exports